"use strict";
exports.__esModule = true;
var MarkerStore = /** @class */ (function () {
    function MarkerStore() {
        this.store = {};
    }
    MarkerStore.prototype.add = function (id, pinOverlay) {
        this.store[id] = pinOverlay;
    };
    MarkerStore.prototype.get = function (id) {
        return this.store[id];
    };
    MarkerStore.prototype.removeById = function (id) {
        this.store[id] = null;
        delete this.store[id];
    };
    MarkerStore.prototype.isExist = function (pinOverlay) {
        var id = pinOverlay.getId();
        return this.store[id] ? true : false;
    };
    MarkerStore.prototype.list = function () {
        return this.store;
    };
    return MarkerStore;
}());
exports["default"] = MarkerStore;
